import {
  team1,
  team2,
  team3,
  team4,
  team5,
  team6,
  team7,
  team8,
  team9,
} from "../../assets/images";

export const TeamData = [
  {
    id: 1,
    imgUrl: team1,
    name: "John Doe",
    designation: "Frontend Developer",
    feedback:
      "Working at Builder.ai has been a game-changer for my career. We’re making technology accessible, empowering creators globally to bring their ideas to life!",
  },
  {
    id: 2,
    imgUrl: team2,
    name: "Alex Chen",
    designation: "Frontend Developer",
    feedback:
      "I’m proud to be part of a team that’s truly transforming software creation. Builder.ai fosters an environment where innovation thrives!",
  },
  {
    id: 3,
    imgUrl: team3,
    name: "Victor Hugo",
    designation: "Frontend Developer",
    feedback:
      "Builder.ai offers a platform where creativity and technology merge seamlessly, creating limitless possibilities for all!",
  },
  {
    id: 4,
    imgUrl: team4,
    name: "Doe Kim",
    designation: "Frontend Developer",
    feedback:
      "Joining Builder.ai has allowed me to be part of an inspiring community, pushing the boundaries of what’s possible in tech.",
  },
  {
    id: 5,
    imgUrl: team5,
    name: "Zaman Ali",
    designation: "Frontend Developer",
    feedback:
      "Builder.ai provides the tools and environment to turn ideas into reality. It's incredible to witness our impact on a global scale!",
  },
  {
    id: 6,
    imgUrl: team6,
    name: "Maya Patel",
    designation: "Frontend Developer",
    feedback:
      "At Builder.ai, I’m constantly inspired by the passion of my colleagues. We’re breaking down barriers and reshaping the tech landscape!",
  },
  {
    id: 7,
    imgUrl: team7,
    name: "Zee Torres",
    designation: "Frontend Developer",
    feedback:
      "This is a place where innovation meets purpose. Builder.ai is leading a software revolution, and I’m excited to be part of it.",
  },
  {
    id: 8,
    imgUrl: team8,
    name: "Ralvan Smith",
    designation: "Frontend Developer",
    feedback:
      "Working at Builder.ai has shown me that technology truly has the power to change lives. We’re making software creation accessible to everyone.",
  },
  {
    id: 9,
    imgUrl: team9,
    name: "Victor Martinez",
    designation: "Frontend Developer",
    feedback:
      "Builder.ai is more than a workplace—it’s a movement. I’m grateful to contribute to making technology accessible for all.",
  },
  {
    id: 10,
    imgUrl: team5,
    name: "Emma Johnson",
    designation: "Frontend Developer",
    feedback:
      "Being at Builder.ai means being part of something larger than myself. We’re reshaping how software is created and experienced globally!",
  },
];
